<template>
    <div>
        <v-dialog v-model="showDialog" width="500px">
            <v-card class="search-modal">
              <v-form class="search-form" @submit.prevent="search">
                <v-text-field
                  outlined
                  prepend-inner-icon="mdi-magnify"
                  v-model="searchPhrase"
                  label="Search similar kennel names"
                ></v-text-field>
                <v-checkbox v-model="permanentOnly" label="Permanent only?"></v-checkbox>
                <div v-if="!searchResults.length">
                    <v-list dense>
                        <v-list-item>
                            <h3>No similar kennel names found</h3>
                        </v-list-item>
                    </v-list>
                </div>
                <div v-if="searchResults.length > 0">
                    <v-list dense>
                        <v-list-item>
                            <h3>Similar kennel names:</h3>
                        </v-list-item>
                        <v-list-item v-for="(name, index) in this.searchResults" :key="index">
                            {{name}}
                        </v-list-item>
                    </v-list>
                </div>        
              </v-form>
            </v-card>
          </v-dialog>
          <a v-on:click="showSimilarNames()">View Similar Names</a>
    </div>      
</template>
<script lang="ts">
import Vue from 'vue';
import { debounce } from "throttle-debounce";

import kennelService from "@/services/admin/kennelService";

export default Vue.extend({
  name: 'KennelSimilarNamesDialog',
  props: {
    kennelSearchPhrase: { type: String },
  },
  components: {
  },
  data: function() {
      return {
        searchResults: [],
        showDialog: false,
        searchPhrase: this.$props.kennelSearchPhrase,
        permanentOnly: true,
        hasSearched: false,
      };
  },
  methods: { 
    showSimilarNames: function() {
      this.showDialog = true;
      this.search();
    },
    search: function(){
      this.$store.dispatch("changeLoaderStatus",true);
      kennelService.getSimilarKennelNames(this.searchPhrase, this.permanentOnly).then((res: any) => {
        this.searchResults = res;
        this.hasSearched = true;
        this.$store.dispatch("changeLoaderStatus",false);
      }).catch(this.$handleError);
    },
  },
  watch: {
    showDialog: function (newVal: boolean) {
      if (!newVal) {
        this.hasSearched = false;
        this.searchResults = [];
      }
      this.showDialog = newVal;
    },
    searchPhrase: {
      handler: debounce(1500,  function(this: any, newValue, oldValue){ this.search();})
    },
    permanentOnly:  function(newVal, oldVal){
      if(newVal != oldVal){
        this.search();
      }
    },
    kennelSearchPhrase: function(newVal, oldVal){
      if(newVal != oldVal){
        this.searchPhrase = newVal;
      }
    }
  }
});
</script>
